import type { TableColumnsType } from 'ant-design-vue'

export const columns: TableColumnsType = [
  {
    title: 'DBT订单号',
    key: 'orderNo',
    dataIndex: 'orderNo',
  },
  {
    title: '三方订单号',
    key: 'newestThirdOrderNo',
    dataIndex: 'newestThirdOrderNo',
  },
  {
    title: '支付渠道',
    key: 'payChnl',
    dataIndex: 'payChnl',
  },
  {
    title: '商品ID',
    key: 'prodId',
    dataIndex: 'prodId',
  },
  {
    title: '订单时间',
    key: 'createDate',
    dataIndex: 'createDate',
  },
  {
    title: '订单类型',
    key: 'payMethod',
    dataIndex: 'payMethod',
  },
  {
    title: '支付状态',
    key: 'payStatus',
    dataIndex: 'payStatus',
  },
  {
    title: '订单金额',
    key: 'amount',
    dataIndex: 'amount',
  },
]

// 支付状态列表
export const payStatusList = [
  {
    value: 0,
    label: '未支付',
    color: 'processing',
  },
  {
    value: 20,
    label: '支付成功',
    color: 'success',
  },
  {
    value: 21,
    label: '支付成功，待上报',
    color: 'success',
  },
  {
    value: 10,
    label: '支付失败',
    color: 'error',
  },
  {
    value: 30,
    label: '已退款',
    color: 'magenta',
  },
]

// 支付类型列表
export const orderTypeList = [
  {
    value: 0,
    label: '现金',
    color: 'green',
  },
  {
    value: 1,
    label: '游戏币',
    color: 'blue',
  },
  {
    value: 2,
    label: '钻石',
    color: 'cyan',
  },
]

// 新增方法，通过id和key获取对应的属性值
export function getPropertyByIdAndKey(id: number, key: string, list: any[]): string {
  const statusItem = list.find((item) => item.value === id)
  return statusItem ? statusItem[key] : '' // 如果状态不存在，返回默认值
}
